import { render, staticRenderFns } from "./RelevantContentsAdd.vue?vue&type=template&id=5a2bccb2&"
import script from "./RelevantContentsAdd.vue?vue&type=script&lang=js&"
export * from "./RelevantContentsAdd.vue?vue&type=script&lang=js&"
import style0 from "./RelevantContentsAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports